import React, { useContext, useState, useEffect } from 'react';
import { Dropdown, Button, CampaignDetailsHeader, HelpPdfDownload } from '../../atoms';
import './kpi-campaign-attr.scss';
import { default as t } from '../../../utils/i18n';
import Checkbox from '@material-ui/core/Checkbox';
import { DashService, AnalysisService } from '../../../services';
import { UserContext, ToasterContext } from '../../../context';
import { format } from 'date-fns'
import { useHistory } from 'react-router-dom';
import queryString from "query-string"


const KpiCampaignAttr = props => {

    const { user } = useContext(UserContext);
    const history = useHistory();
    const [kpis, setKpis] = useState([]);
    const [selectedKpi, setSelectedKpi] = useState([]);
    const [listOfKpis, setListOfKpis] = useState([]);

    const [campaignAttributes, setCampaignAttributes] = useState([]);

    const [campaignDetails, setCampaignDetails] = useState([]);

    const [kpiWarning, setKpiWarning] = useState(false);

    const { message, setMessage } = useContext(ToasterContext);

    const userAccessToken = user?.tokens?.accessToken?.jwtToken;
    const username = user?.username;

    const location = queryString?.parse(window.location.search)
    const campaignId = location?.id;
    const kpiSysId = location?.sys_id;


    useEffect(() => {
      getCampaignDetails();
      getCampaignAttr();
    }, []);

    const handleBackClick = e => {
        props.handleBackClick(e);
    };

    const checkOrUnCheckAttr = (attr, index) => (value) => {
      campaignAttributes[index].is_active = value.target.checked;
      setCampaignAttributes([...campaignAttributes])
    };

    const handleKpiSelect = (selectedKpi) => {
      const selectedKpiValue = listOfKpis.find(kpi => kpi.sys_id === selectedKpi.value);
      if(selectedKpiValue.mapped_campaign_objectives && selectedKpiValue.mapped_campaign_objectives.length > 0) {
        if(!selectedKpiValue.mapped_campaign_objectives.includes(campaignDetails.objective)) {
          setKpiWarning(true);
        } else {
          setKpiWarning(false);
        }
      } 
      setSelectedKpi(selectedKpi);
      campaignAttributes.filter(attr => {
        if(attr.is_active === false) {
          attr.is_active = true;
        }
      });
      setCampaignAttributes([...campaignAttributes]);
    }

    async function getKpiList(obj) {
      try {
        const kpiResponse = await DashService.kpiList(userAccessToken, username, campaignId, true);
        const kpiListRes = kpiResponse.data?.data;
        const kpiList = [...kpiListRes];
        const dropDownKpiOptions = kpiList.map(kpi => ({
          value: kpi.sys_id,
          label: kpi.KPI_Metric,
          isdisabled: kpi?.isDisabled
        }));
        let includedObjectives = [];
        let noncludedObjectives = [];
        kpiList.forEach(kpi => {
          if(kpi?.isDisabled) {
            kpi.KPI_Metric = `${kpi.KPI_Metric}`;
          }
          if(kpi.mapped_campaign_objectives && kpi.mapped_campaign_objectives.length > 0) {
            if(kpi.mapped_campaign_objectives.includes(obj)) {
              includedObjectives.push({value: kpi.sys_id,
                label: kpi.KPI_Metric, isdisabled: kpi?.isDisabled})
            } else {
              noncludedObjectives.push({value: kpi.sys_id,
                label: kpi.KPI_Metric, isdisabled: kpi?.isDisabled})
            }
          }
        });
        let options = [];
        options.push({groupOptions: includedObjectives, name: 'KPI’s corresponding with Current Objectives'});
        options.push({groupOptions: noncludedObjectives, name: 'KPI’s Corresponding to Other Objectives'});
        setKpis(options);
        setListOfKpis(kpiList);
        if(kpiSysId) {
          const matchSysId = dropDownKpiOptions.find(kpi => kpi.value === kpiSysId);
          if(matchSysId) {
            setSelectedKpi(matchSysId);
          }
        }
      } catch (error) {
      }
    }

    async function getCampaignAttr() {
      try {
        const campaignAttrResponse = await DashService.strategicAttrList(userAccessToken, username);
        const attrList = campaignAttrResponse.data?.data;
        const campaignAttrList = [...attrList];
        setCampaignAttributes(campaignAttrList)
      } catch(error) {
      }
    }

    async function getCampaignDetails() {
      try {
        const campaignDetailsResponse = await AnalysisService.getCampaignDetails(userAccessToken, username, campaignId);
        const campaignDetailsResp  = campaignDetailsResponse.data?.data;
        campaignDetailsResp.start_time = updateDateFormat(campaignDetailsResp.start_time);
        campaignDetailsResp.stop_time = updateDateFormat(campaignDetailsResp.stop_time);
        campaignDetailsResp.budget= campaignDetailsResp?.budget === 'Not Set' ? campaignDetailsResp?.budget : nFormatter(campaignDetailsResp?.budget,1) + '(' + capitalizeFirstLetter(campaignDetailsResp?.budget_mode) +')';
        setCampaignDetails(campaignDetailsResp)
        if(campaignDetailsResp?.objective) {
          getKpiList(campaignDetailsResp?.objective);
        }
      } catch(error) {

      }
    }

    const updateDateFormat = val => {
      const d = new Date(val);
      d.setUTCHours(0,0,0,0);
      const yyyy = d.getFullYear();
      let mm = d.getMonth() + 1;
      let dd = d.getDate();
      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;
      return dd + '/' + mm + '/' + yyyy;
    };

    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  
    const nFormatter = (num, digits) => {
      const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "K" }
      ]
      const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
      const item = lookup.slice().reverse().find((item) => {
        return num >= item.value
      })
      return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0"
    }


    const onAnalysis = async () => {
      try {
        const unSelectedAttr = campaignAttributes.filter(attr => !attr.is_active).map(res => res.sys_id);
        const payload = {
          kpi: selectedKpi.value,
          campaignId: campaignDetails.id,
          non_negotiable_attributes: unSelectedAttr
        }
        const analysisResponse = await AnalysisService.analysisRequest(userAccessToken, username, payload);
        const analysisReqResponse = analysisResponse.data?.data;
        setMessage({message: t('analyse.success'), isError: false})
        history.push('/optimization');
      } catch(error) {
        setMessage({message: t('analyse.error') , isError: true})
        history.push('/optimization');
      }
    }


    return (
        <section>
          <div className="kpi-campaigns-details">

            <div className="heading-btn-container">
              <button className="return-insights" onClick={() => handleBackClick()}>
                <i className="eva  eva-arrow-ios-back-outline"></i>
                {t('kpi.attr.button-back')}
              </button>
            </div>
            <div className='campaign'>
              <CampaignDetailsHeader
              campaignDetails = {campaignDetails}
              />
            </div>
 
            <div className="kpi-campaigns-container-details">
              <h3>{t('kpi.attr.heading')}</h3>
              <span className='kpi-sub-heading'>{t('kpi.attr.subHeading')}</span>
              <div className='help-pdf-kpi'>
              <HelpPdfDownload/>
              </div>
              <div className="kpi-select-container">
                <div className="import-left">
                  <Dropdown
                    heading={t('kpi.attr.select.kpi')}
                    tooltipIndicator={true}
                    options={kpis}
                    value={selectedKpi}
                    placeholder={t('analyse.list')}
                    onSelect={handleKpiSelect}
                    tooltipId={t('kpi-list')}
                    infoData={t('analysis.kpi')}
                    isMultiCategory={true}
                  />
                </div>
              </div>

             
              <div className="kpi-warn">
              {kpiWarning && 
              <div>
                <i className='eva eva-alert-circle-outline warn-icon'></i>
                <span className='warning'>{t('kpi.attr.warning')}</span>
              </div>
                }
              </div>
            {campaignAttributes && campaignAttributes.length > 0 && 
              <div>
                <div className='campaign-attr-container'>
                  <h4>{t('kpi.attr.campaignAttr.heading')}</h4>
                  <span>{t('kpi.attr.campaignAttr.subHeading')}</span>
                </div>

                <div className="campaign-attr">
                  {campaignAttributes.map((attr, index) => (
                    <span className='checkbox-name align-items'>
                    <Checkbox 
                      value={attr}
                      key={attr}
                      checked={attr.is_active}
                      onChange={checkOrUnCheckAttr(attr, index)}
                    />
                    <label style={{padding: '10px'}} title={attr.attribute_metric}>{attr.attribute_metric}</label>
                    </span>
                  ))}
                </div>
              </div>
            }

              <div className="analyse-button">
                <div className="dsh-details-container--actions--reset">
                  <Button 
                    disabled={!selectedKpi.label}
                    label={t('kpi.attr.analyze')} 
                    handleClick={onAnalysis}
                  />
                </div>
              </div>

            </div>
          </div>
        </section>
      );
}
export default KpiCampaignAttr;